import { FileText } from 'lucide-react'
import { Card } from '@/components/ui/card'

interface BacklogStatsCardsProps {
  totalWorkItems: number
}

export function BacklogStatsCards({ totalWorkItems }: BacklogStatsCardsProps) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6" data-testid="backlog-stats-cards">
      <Card className="flex items-center gap-4 px-5 py-4" data-testid="total-work-items-card">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground">
          <FileText className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="text-xs text-muted-foreground">Total Work Items</p>
          <p className="text-2xl font-bold">{totalWorkItems}</p>
        </div>
      </Card>
    </div>
  )
}
